import axios from 'axios'
import * as common from './common'
import * as api from './api'

/**
 * 获取用户信息的API服务
 */
export class UserService {
  /**
   * 获取用户信息
   * @param {string} sid - 会话ID
   * @param {string} openID - 用户OpenID
   * @returns {Promise<object>} API响应数据
   */
  static async getUserInfo(sid, openID) {
    try {
      const { data } = await axios({
        url: common.cloudPayUrl + '/pub/' + api.urlList.pay.bill.park_plate.get_self_info,
        method: 'POST',
        data: {
          sid: sid,
          openid: openID
        },
        header: {
          'content-type': 'application/json'
        }
      })
      return data
    } catch (e) {
      throw e
    }
  }

  /**
   * 绑定手机号
   * @param {string} sid - 会话ID
   * @param {string} openID - 用户OpenID
   * @param {string} phoneNumber - 手机号
   * @returns {Promise<object>} 绑定结果
   */
  static async bindPhoneNumber(sid, openID, phoneNumber) {
    try {
      const { data } = await axios({
        url: common.cloudPayUrl + '/pub/' + api.urlList.pay.bill.park_plate.bind_phone_number,
        method: 'POST',
        data: {
          sid: sid,
          openid: openID,
          version: 'v2',
          phone_number: phoneNumber
        },
        header: {
          'content-type': 'application/json'
        }
      })
      return data
    } catch (e) {
      throw e
    }
  }
}
